import React, { useCallback, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import { Form } from '@availity/form';
import { useLocation } from 'react-router-dom';

import CustomProgressBar from './CustomProgressBar';

const ProgressValidatedForm = props => {
  const {
    children,
    enableReinitialize,
    initialValues,
    onSubmit,
    pages,
    validationSchema,
    ...restProps
  } = props;

  const formRef = useRef(null);
  const [pendingRoute, setPendingRoute] = useState(undefined);
  const location = useLocation();

  const getTargetRoute = useCallback(page => page.href.replace('#', '/'), []);

  const handleProgressStepClick = useCallback((page, event) => {
    const targetRoute = getTargetRoute(page);

    if (targetRoute === location.pathname) {
      setPendingRoute(undefined);
      event.preventDefault();
      return;
    }

    event.preventDefault();
    setPendingRoute(targetRoute);
    if (formRef.current) {
      formRef.current.handleSubmit();
    }
  }, [getTargetRoute, location.pathname]);

  const handleFormChangeCapture = useCallback(() => {
    if (pendingRoute !== undefined) {
      setPendingRoute(undefined);
    }
  }, [pendingRoute]);

  const handleSubmit = useCallback(() => {
    const routeToNavigate = pendingRoute;
    if (routeToNavigate !== undefined) {
      setPendingRoute(undefined);
    }
    return onSubmit(routeToNavigate);
  }, [onSubmit, pendingRoute]);

  return (
    <>
      <CustomProgressBar pages={pages} onStepClick={handleProgressStepClick} />
      <Form
        {...restProps}
        innerRef={formRef}
        enableReinitialize={enableReinitialize}
        initialValues={initialValues}
        onChangeCapture={handleFormChangeCapture}
        onSubmit={handleSubmit}
        validationSchema={validationSchema}
      >
        {children}
      </Form>
    </>
  );
};

ProgressValidatedForm.propTypes = {
  children: PropTypes.node,
  enableReinitialize: PropTypes.oneOfType([PropTypes.bool, PropTypes.object]),
  initialValues: PropTypes.object,
  onSubmit: PropTypes.func,
  pages: PropTypes.array,
  validationSchema: PropTypes.object,
};

export default ProgressValidatedForm;
